<template>
  <div>
    <please-wait-modal/>
    <h6 class="m-0 font-weight-bold text-primary">Pick Helper</h6>
    <custom-table
      :arr="arr"
      :arr_id="arr_id"
      :total_page="total_page"
      :url_update="'/user?is_publish=1&is_suspend=0&type=active&helper_sub_category_id='+this.invoice.helper_sub_category_id+'&work_at_city_id='+this.invoice.city_id"
      :is_action="true"
      action_text="Pick"
      @on_action="pick"
      :arr_header="arr_header"
      @on_refresh_start="on_refresh_start"
      @on_refresh_end="on_refresh_end"/>
  </div>
</template>

<script>
import custom_table from '@/layout/table'
import please_wait_modal from '@/layout/please_wait_modal'

export default{
  components:{
    'custom-table': custom_table,
    'please-wait-modal': please_wait_modal,
  },
  data(){
    return{
      arr: [],
      arr_id: [],
      total_page: 0,
      arr_header: [],
      invoice: {},
    }
  },
  async created(){
    await this.get_invoice_data()
    await this.get_data()
  },
  methods:{
    on_refresh_start(){
      this.is_loading = true
    },
    on_refresh_end(){
      this.is_loading = false
    },
    async get_data(){
      try{
        var response = await axios.get(base_url+'/user?is_verified=1&is_publish=1&is_suspend=0&api_type=web-admin&type=active&helper_sub_category_id='+this.invoice.helper_sub_category_id+'&work_at_city_id='+this.invoice.city_id)

        var response_data = response.data
        if(response_data.status == "success"){
          this.arr = response_data.arr
          this.arr_id = response_data.arr_id
          this.total_page = response_data.total_page
          this.arr_header = response_data.arr_header
        }
        else
          this.$toasted.show(response_data.message)
      } catch(e){
        this.$toasted.show(e)
      }
    },
    async get_invoice_data(){
      try{
        var response = await axios.get(base_url+'/order-call?id='+this.$route.query.id)

        var response_data = response.data
        if(response_data.status == "success"){
          this.invoice = response_data.data
          this.invoice.date = moment(response_data.data.created_at)
          this.invoice.scheduled_at = moment(response_data.data.scheduled_at)
          this.invoice.end_at = moment(response_data.data.end_at)
        }
        else
          this.$toasted.show(response_data.message)
      } catch(e){
        this.$toasted.show(e)
      }
    },
    async pick(data){
      try{
        $('#please_wait_modal').modal('show')
        var data1 = {}
        data1.id = this.$route.query.id
        data1.helper = {
          id: data.data.id
        }

        var response = await axios.put(base_url+'/order-call/pick',data1)

        $('#please_wait_modal').modal('hide')
        var response_data = response.data
        if(response_data.status == "success"){
          location.href = "/order-call/detail?id="+this.$route.query.id
        }
        else
          this.$toasted.show(response_data.message)
      } catch(e) {
        $('#please_wait_modal').modal('hide')
        this.$toasted.show(e)
      }
    },
  },
}
</script>
